export const ANALYTICS_EVENTS = {
  INTERVIEW_SENT: 'interview_sent',
  CANDIDATE_STAGE_CHANGED: 'candidate_stage_changed',
  INTERVIEW_LINK_COPIED: 'interview_link_copied'
} as const;

export type AnalyticsEvent = (typeof ANALYTICS_EVENTS)[keyof typeof ANALYTICS_EVENTS];

export interface AnalyticsContext {
  tenantId?: string;
  orgId?: string;
  deptId?: string;
  userId?: string;
  jobId?: string;
  applicationId?: string;
}

export type CommChannel = 'email' | 'sms' | 'whatsapp' | 'manual';
export type StageChangeSource = 'kanban' | 'detail_page';
